import { z } from 'zod';
/**
 * Subscription tier enum
 */
export const SubscriptionTierSchema = z.enum(['free', 'starter', 'professional', 'enterprise']);
/**
 * Subscription status enum
 */
export const SubscriptionStatusSchema = z.enum([
    'active',
    'trialing',
    'past_due',
    'canceled',
    'unpaid',
    'incomplete',
    'incomplete_expired',
    'paused',
]);
/**
 * Usage metrics schema
 */
export const UsageMetricsSchema = z.object({
    activeEngineers: z.number().int().nonnegative(),
    prsReviewed: z.number().int().nonnegative(),
    estimatedCost: z.number().nonnegative(),
});
/**
 * Billing status response schema
 */
export const BillingStatusSchema = z.object({
    tier: SubscriptionTierSchema,
    status: SubscriptionStatusSchema.nullable(),
    seats: z.number().int().nonnegative(),
    currentPeriodStart: z.string().datetime(),
    currentPeriodEnd: z.string().datetime(),
    trialEndedAt: z.string().datetime().nullable(),
    cancelAtPeriodEnd: z.boolean().default(false),
    usage: UsageMetricsSchema.optional(),
    nextInvoice: z
        .object({
        amount: z.number(),
        currency: z.string(),
        dueDate: z.string().datetime(),
    })
        .nullable()
        .optional(),
    billingDataStale: z.boolean().optional(),
    staleReason: z.enum(['provider_unavailable']).nullable().optional(),
    setupCompleted: z.boolean().default(false),
});
/**
 * Billing portal session response schema
 */
export const BillingPortalSessionSchema = z.object({
    url: z.string().url(),
});
/**
 * Invoice schema
 */
export const InvoiceSchema = z.object({
    invoiceId: z.string(),
    organizationId: z.string().uuid(),
    amountPaid: z.string(),
    currency: z.string(),
    status: z.string(),
    hostedInvoiceUrl: z.string().url().nullable(),
    invoicePdfUrl: z.string().url().nullable(),
    createdAt: z.string().datetime(),
});
/**
 * Paginated invoices response schema
 */
export const InvoicesResponseSchema = z.object({
    invoices: z.array(InvoiceSchema),
});
/**
 * Budget settings and derived spend status.
 */
export const BudgetSettingsResponseSchema = z.object({
    organizationId: z.string().uuid(),
    hardBudgetUsd: z.string(),
    softThresholdPercent: z.number().int().min(1).max(100),
    currentSpendUsd: z.number().nonnegative(),
    softThresholdUsd: z.number().nonnegative(),
    remainingBudgetUsd: z.number(),
    periodResetDate: z.string().datetime(),
    isSoftThresholdExceeded: z.boolean(),
    isOverBudget: z.boolean(),
});
/**
 * Structured response for reviews blocked by budget policy.
 */
export const BudgetBlockedResponseSchema = z.object({
    code: z.literal('BUDGET_EXCEEDED'),
    message: z.string(),
    resetDate: z.string().datetime(),
    settingsUrl: z.string().url(),
});
//# sourceMappingURL=billing.js.map